import styled, { css } from 'styled-components'

export const ActivityItem = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.default};
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  /* Highlight search matches */
  mark {
    background: ${({ theme }) => theme.colors.warningLight};
    color: ${({ theme }) => theme.colors.text.primary};
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    border-radius: ${({ theme }) => theme.borderRadius.small};
  }
`

export const ActivityIcon = styled.div<{ $type: 'create' | 'delete' }>`
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
    stroke-width: 2;
  }

  ${({ $type, theme }) =>
    $type === 'create'
      ? css`
          background: ${theme.colors.successLight};
          color: ${theme.colors.success};
        `
      : css`
          background: rgba(255, 59, 48, 0.1);
          color: ${theme.colors.danger};
        `}
`

export const ActivityContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const ActivityAction = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing.micro};

  strong {
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  }
`

export const ActivityDetails = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.micro};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ActivityTimestamp = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  color: ${({ theme }) => theme.colors.text.tertiary};
`
